import { render, staticRenderFns } from "./dishonestyReason.vue?vue&type=template&id=67d313e2"
import script from "./dishonestyReason.vue?vue&type=script&lang=js"
export * from "./dishonestyReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports